import { ProfileTranslationsEn } from '../Pages/Profile/translations/en';

export const UserPageTranslationsEn = { profilePage: ProfileTranslationsEn };
